import React from "react";
import { Button, Checkbox, Form, Icon, Input, message } from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import {
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGithubSignIn,
  userGoogleSignIn,
  userSignIn,
  userTwitterSignIn,
} from "appRedux/actions/Auth";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "components/CircularProgress/index";

const FormItem = Form.Item;

class SignIn extends React.Component {
  componentDidUpdate() {
    if (this.props.authUser !== null) {
      this.props.history.push("/");
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        //  console.log("Value ==> ", values);
        this.props.showAuthLoader();
        this.props.userSignIn(values);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { showMessage, loader, alertMessage } = this.props;

    return (
      <div
        className="gx-app-login-wrap"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          backgroundColor: "#f4f5f7",
        }}
      >
        <div
          className="gx-app-login-container"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          {/* Main Card Container */}
          <div
            className="gx-app-login-main-content"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.08)",
              padding: "40px 50px",
              maxWidth: "750px",
              width: "100%",
              gap: "0px",
            }}
          >
            {/* Left Side: Logo — fixed width, centered */}
            <div
              className="gx-app-logo-content"
              style={{
                width: "220px",
                flexShrink: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingRight: "40px",
                borderRight: "1px solid #f0f0f0",
              }}
            >
              <div
                style={{
                  width: "160px",
                  height: "160px",
                  borderRadius: "50%",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.12)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                <img
                  alt="logo"
                  src={require("assets/images/logo.png")}
                  style={{
                    width: "120px",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              </div>
            </div>

            {/* Right Side: Form */}
            <div
              className="gx-app-login-content"
              style={{
                flex: 1,
                paddingLeft: "50px",
              }}
            >
              <Form
                onSubmit={this.handleSubmit}
                className="gx-signin-form gx-form-row0"
              >
                <FormItem style={{ marginBottom: "16px" }}>
                  {getFieldDecorator("mobile", {
                    rules: [
                      {
                        required: true,
                        message: "The input is not valid Mobile!",
                      },
                    ],
                  })(
                    <Input
                      placeholder="Mobile Number"
                      style={{
                        backgroundColor: "#f0f0f5",
                        border: "1px solid #e8e8f0",
                        height: "44px",
                        borderRadius: "4px",
                        fontSize: "14px",
                        color: "#333",
                      }}
                    />,
                  )}
                </FormItem>

                <FormItem style={{ marginBottom: "24px" }}>
                  {getFieldDecorator("pin", {
                    rules: [
                      { required: true, message: "Please input your Pin!" },
                    ],
                  })(
                    <Input
                      type="password"
                      placeholder="Pin"
                      style={{
                        backgroundColor: "#f0f0f5",
                        border: "1px solid #e8e8f0",
                        height: "44px",
                        borderRadius: "4px",
                        fontSize: "14px",
                      }}
                    />,
                  )}
                </FormItem>

                <FormItem style={{ marginBottom: 0 }}>
                  <Button
                    type="primary"
                    className="gx-mb-0"
                    htmlType="submit"
                    style={{
                      backgroundColor: "#4a3298",
                      borderColor: "#4a3298",
                      padding: "0 28px",
                      height: "40px",
                      fontSize: "14px",
                      borderRadius: "4px",
                      fontWeight: "500",
                    }}
                  >
                    <IntlMessages id="app.userAuth.signIn" />
                  </Button>
                </FormItem>
              </Form>
            </div>

            {loader ? (
              <div className="gx-loader-view">
                <CircularProgress />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(SignIn);

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser } = auth;
  return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps, {
  userSignIn,
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGoogleSignIn,
  userGithubSignIn,
  userTwitterSignIn,
})(WrappedNormalLoginForm);
